import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import IconSvg from './IconSvg';

const ImageCheckbox = ({ image, onChange, text, value }) => {
  const [imageLoaded, setImageLoaded] = useState(false);

  const imageEl = useRef();
  const showImage = imageEl && (imageLoaded || imageEl.complete);

  const onLoad = () => {
    setImageLoaded(true);
  };

  const onError = (e) => {
    e.target.src =
      'https://resources.redbull.tv/linear-borb/rbtv_background_landscape/im:i:h_192,c_fill';
  };

  return (
    <label
      className={`checkbox checkbox--image ${showImage ? 'show' : 'hide'}`}
    >
      <input type="checkbox" value={value} onChange={onChange} />
      <div className="checkbox__indicator">
        <img
          ref={imageEl}
          src={image}
          alt={text}
          onLoad={onLoad}
          onError={onError}
        />
        <div className="checkbox__icon">
          <IconSvg type="checkmark" />
        </div>
      </div>
      <span className="checkbox__text">{text}</span>
    </label>
  );
};

ImageCheckbox.propTypes = {
  image: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  text: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
};

ImageCheckbox.defaultProps = {
  image:
    'https://resources.redbull.tv/linear-borb/rbtv_background_landscape/im:i:h_192,c_fill',
};

export default ImageCheckbox;
